import { Time, DefinedTime } from '../types'
import { getMinuteTotal } from './getMinuteTotal'

export const computeTime = (
  time: DefinedTime,
  duration: DefinedTime,
  target: 'start' | 'end',
): Time => {
  const timeMarkInMinutes = getMinuteTotal(time)
  const durationInMinutes = getMinuteTotal(duration)

  const computedTimeInMinutes =
    target === 'start'
      ? timeMarkInMinutes - durationInMinutes
      : timeMarkInMinutes + durationInMinutes

  // If result would be negative, clamp to 0:0
  // in some cases, we were getting -0 as a result
  if (computedTimeInMinutes < 0) return { hour: 0, minute: 0 }

  return {
    hour: Math.floor(computedTimeInMinutes / 60),
    minute: computedTimeInMinutes % 60,
  }
}
